export function useIsLocal() {
  return Boolean(window.location.href.includes('local'));
}

export function useBroadcastTimezone(timezones: Record<string, string>) {
  return Object.keys(timezones).map((b) => ({
    id: b,
    name: b,
  }));
}

export function usePlayoutTimezone(timezones: Record<string, string>) {
  return Object.keys(timezones).map((b) => ({
    id: timezones[b],
    name: b,
  }));
}
